import { forwardRef, ReactNode } from 'react';
import { Button, ButtonProps } from 'antd';

export type AppPrimaryButtonProps = {
  children: ReactNode;
} & ButtonProps;

export type AppPrimaryButtonHandle = HTMLButtonElement;

export const AppPrimaryButton = forwardRef<AppPrimaryButtonHandle, AppPrimaryButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <Button {...props} ref={ref} type="primary">
        {children}
      </Button>
    );
  }
);
